export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-information-line text-primary-400 mr-2"></i>
            关于我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500">了解91黑料吃瓜网的使命与坚持</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Text */}
          <div>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              91黑料吃瓜网成立于2024年，是国内领先的娱乐八卦与黑料事件聚合平台。我们致力于为用户提供最快、最全、最真实的娱乐围观体验——无论是明星动态、影视八卦、综艺黑幕还是网红圈层爆料，你都能在这里第一时间吃到最新鲜的瓜。
            </p>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              平台每日滚动更新超过200条内容，覆盖全网主流信息源。我们坚持"快速、全面、理性"的原则：快速采集最新线索，全面呈现多方视角，理性引导围观文化。91黑料吃瓜在线不仅是信息聚合平台，更是健康吃瓜文化的倡导者。
            </p>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
              在信息爆炸的时代，黑料吃瓜爆料不停——我们要做的不是制造混乱，而是帮你理清脉络、辨别真伪，让你在这场娱乐盛宴中始终保持清醒。吃瓜黑料网，做有态度的围观者。
            </p>

            <div className="flex flex-wrap gap-4 mt-6">
              {['快速更新', '全面覆盖', '理性吃瓜', '用户至上'].map((tag) => (
                <span key={tag} className="px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-primary-400 text-xs font-medium">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20abstract%20editorial%20image%20with%20deep%20crimson%20and%20charcoal%20tones%2C%20warm%20atmospheric%20glow%2C%20fine%20art%20texture%2C%20mysterious%20and%20professional%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=about-91hl&orientation=landscape"
              alt="91黑料吃瓜网 - 平台介绍"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950/50 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}